import type { FaireProductEntity } from "../../entity_types/product";

export const p_crc6823aqw: FaireProductEntity = {
  token: "p_crc6823aqw",
  type: "product",
  name: "Sleep Aid, Relax the mind & body",
  brandToken: "b_8btzh8m7qg",
  brandName: "My Balance",
  imageUrl:
    "https://cdn.faire.com/fastly/4b4fab75c0587f56bad1e62079a51067603b1ec38700680f3a3cead7249981ed.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9ee234b6338b0273fd4aecd1a3bd0e12fb0470d98da66e33f38e290ea9291f9.png",
    "https://cdn.faire.com/fastly/b64b7b93bd15597e0dfa08393a16fa9a7bfa4941a5d6f0aab8b865c5ecc50dea.png",
  ],
  priceDollars: 11.98,
  description:
    "\nThis proprietary blend of natural ingredients include. \n\nMelatonin, Chamomile and Vitamin B-6.  This natural blend has been formulated to aid the body in obtaining more restful sleep. Our Sleep Aid Formula contains relaxing vitamins, minerals and herbs. When taken as directed, Sleep Aid Formula may help decrease feelings of worry and stress while falling asleep and sleeping through the night.\n",
  tags: [],
  msrpDollars: 19.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:35.725Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
